import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "creteNewReferee" }
const _hoisted_2 = { class: "formContent" }
const _hoisted_3 = { class: "overflowDiv" }
const _hoisted_4 = { class: "dateSec" }
const _hoisted_5 = { class: "dateSec" }
const _hoisted_6 = { class: "footersec" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_month_picker = _resolveComponent("a-month-picker")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_form, {
        ref: "addRefereeFormRef",
        model: _ctx.addRefereeModal,
        rules: _ctx.addRefereeRules,
        "label-col": _ctx.labelCol,
        "wrapper-col": _ctx.wrapperCol,
        colon: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_form_item, {
              label: "This Referee is/ was my",
              required: "",
              name: "referee_relationship"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.addRefereeModal.referee_relationship,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addRefereeModal.referee_relationship) = $event)),
                  type: "text",
                  placeholder: "",
                  "allow-clear": "",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "Referee's First Name",
              required: "",
              name: "first_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.addRefereeModal.first_name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addRefereeModal.first_name) = $event)),
                  type: "text",
                  placeholder: "",
                  "allow-clear": "",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "Referee's Last Name",
              required: "",
              name: "last_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.addRefereeModal.last_name,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addRefereeModal.last_name) = $event)),
                  type: "text",
                  placeholder: "",
                  "allow-clear": "",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              ref: "company",
              required: "",
              label: "Referee's Company Name",
              name: "company"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "",
                  value: _ctx.addRefereeModal.company,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addRefereeModal.company) = $event)),
                  type: "text",
                  "allow-clear": "",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "email",
              required: "",
              label: "Referee's Email",
              name: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "",
                  value: _ctx.addRefereeModal.email,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addRefereeModal.email) = $event)),
                  type: "text",
                  "allow-clear": "",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "phone",
              label: "Referee's Phone",
              name: "phone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.addRefereeModal.phone,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addRefereeModal.phone) = $event)),
                  placeholder: "",
                  "allow-clear": "",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              label: "Question Profile",
              required: "",
              name: "profile_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.addRefereeModal.profile_id,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addRefereeModal.profile_id) = $event)),
                  placeholder: "",
                  "show-search": "",
                  "filter-option": _ctx.filterOption,
                  mode: "multiple"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidateQprofiles, (profile) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: profile.id,
                        key: profile.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(profile.profile_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "filter-option"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              ref: "candidate_job",
              label: "Candidate Job Title",
              name: "candidate_job"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.addRefereeModal.candidate_job,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addRefereeModal.candidate_job) = $event)),
                  placeholder: "",
                  "allow-clear": "",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_form_item, {
                ref: "workstartmonth",
                required: "",
                label: "Candidate Started Working Here",
                name: "workstartmonth",
                class: "dateSec1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_month_picker, {
                    value: _ctx.addRefereeModal.workstartmonth,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.addRefereeModal.workstartmonth) = $event)),
                    "allow-clear": "",
                    placeholder: "Select month",
                    format: "MMMM"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 512),
              _createVNode(_component_a_form_item, {
                ref: "workstartyear",
                required: "",
                name: "workstartyear",
                class: "dateSec2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_date_picker, {
                    value: _ctx.addRefereeModal.workstartyear,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.addRefereeModal.workstartyear) = $event)),
                    mode: "year",
                    "allow-clear": "",
                    format: "YYYY",
                    placeholder: "Select year",
                    onFocus: _ctx.getfocus1,
                    showToday: false,
                    open: _ctx.startYearOpen,
                    onPanelChange: _ctx.handlePanelChange1
                  }, null, 8, ["value", "onFocus", "open", "onPanelChange"])
                ]),
                _: 1
              }, 512)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_form_item, {
                ref: "workendmonth",
                label: "Candidate Finished Working Here",
                name: "workendmonth",
                class: "dateSec1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_month_picker, {
                    value: _ctx.addRefereeModal.workendmonth,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.addRefereeModal.workendmonth) = $event)),
                    "allow-clear": "",
                    placeholder: "Select month",
                    format: "MMMM"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 512),
              _createVNode(_component_a_form_item, {
                ref: "workendyear",
                name: "workendyear",
                class: "dateSec2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_date_picker, {
                    value: _ctx.addRefereeModal.workendyear,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.addRefereeModal.workendyear) = $event)),
                    mode: "year",
                    "allow-clear": "",
                    placeholder: "Select year",
                    format: "YYYY",
                    onFocus: _ctx.getfocus2,
                    open: _ctx.endYearOpen,
                    onPanelChange: _ctx.handlePanelChange2
                  }, null, 8, ["value", "onFocus", "open", "onPanelChange"])
                ]),
                _: 1
              }, 512)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_button, {
              class: "cancle",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.cancelAddReferee()))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              class: "add",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addNewReferee())),
              loading: _ctx.confirmLoading
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules", "label-col", "wrapper-col"])
    ])
  ]))
}